const ENDPOINT = 'GETuserLibrarySections';
function getUserLibrarySections(gateway, params = {}) {
    return gateway.get(getUserLibrarySections.endpoint, params);
}
getUserLibrarySections.endpoint = ENDPOINT;

export { getUserLibrarySections as default };
//# sourceMappingURL=getUserLibrarySections.js.map
